// main.js
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import SamanZoomer  from  'saman-zoomer'
import   'saman-zoomer/dist/saman-zoomer.css'
import Toast, { POSITION }  from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import VueFileAgent from 'vue-file-agent';
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css';
 



import VuePersianDatetimePicker from 'vue-persian-datetime-picker';


 
Vue.component('date-picker', VuePersianDatetimePicker);
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  position: POSITION.BOTTOM_CENTER  ,
  newestOnTop: true,
  rtl: true,
});

Vue.use(SamanZoomer)
Vue.prototype.$baseaddress="http://172.168.115.5:8080"

//export const bus = new Vue();

Vue.prototype.$bus = new Vue()

Vue.use(VueFileAgent);

Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
